import graphql__b696782b7e9bcbbfe287 from "./__generated__/SendPasswordResetMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__b696782b7e9bcbbfe287;

function sendPasswordReset(form, onCompleted) {
  const variables = mapValues(form.fields, field => field.value);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { sendPasswordReset };
